import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { Modal, Spinner } from 'reactstrap'
import { callApi } from '../../../../ApiHelper/ApiHelper';
import { apiUrl } from '../../../../ApiHelper/ApiUrl';
import { useForm, Controller } from 'react-hook-form';
import { DatePicker } from "rsuite";
import moment from 'moment';
import { printData } from '../../../../utility/CommonFunctions';

export default function AddHolidayModal({ isOpen, onClose, EditHolidaysData, setState, getHoliday }) {
    const { register, handleSubmit, formState: { errors }, clearErrors, watch, reset, setValue, control } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [stateOffice, setStateOffice] = useState({
        officeList: []
    });

    // Handle form submission
    const onSubmit = (data) => {
        // console.log('Form Data:', data);
        const postData = {
            holidayName: data?.holidayName,
            holidayDate: data?.holidayDate,
            description: data?.description
        };


        const option = {
            method: 'POST',
            data: postData, // Use 'body' for FormData
        };

        setIsLoading(true);

        const endPoint = EditHolidaysData !== null ? apiUrl.add_holiday + `?holidayId=${EditHolidaysData?.id}` : apiUrl.add_holiday;
        // Call the API
        callApi(endPoint, option)
            .then((res) => {
                if (res?.status === true) {
                    toast.success(res?.message);
                    getHoliday();
                    setState((pre) => ({ ...pre, EditHolidaysData: null }));
                    onClose();
                    reset();
                } else {
                    toast.error(res?.message);
                    reset();
                }
            })
            .catch(() => {
                toast.error('An error occurred');
                reset()
            })
            .finally(() => setIsLoading(false));

    }


    useEffect(() => {
        if (isOpen) {
            GetOfficeList();
        }
        if (EditHolidaysData !== null) {
            const holidayDate = moment(EditHolidaysData?.holidayDate).format("YYYY-MM-DD")
            setValue('holidayName', EditHolidaysData?.holidayName);
            setValue('holidayDate', holidayDate);
            setValue('description', EditHolidaysData?.description);
        } else {
            reset();
        }
    }, [EditHolidaysData, isOpen]);

    const GetOfficeList = () => {
        callApi(apiUrl.get_site + "?type=office", { method: "GET" }).then((res) => {
            if (res?.status) {
                printData(res);
                setStateOffice((pre) => ({
                    ...pre,
                    officeList: res?.data?.site
                }))
            } else {
                toast.error(res?.message)
            }
        })
    }


    return (
        <Modal
            className="modal-dialog modal-dialog-centered modal-md holiday-modal"
            isOpen={isOpen}
            toggle={() => {
                clearErrors();
                onClose();
                reset();
                setState((pre) => ({ ...pre, EditHolidaysData: null }));
            }}
        >
            <div className="modal-content shadow-lg">
                <div className="modal-header p-4">
                    <h1
                        className="modal-title fs-3 rajdhani-semibold"
                        id="addHolidayModalLabel"
                    >
                        {EditHolidaysData ? "Edit" : "Add"} Holiday
                    </h1>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => {
                            clearErrors();
                            onClose();
                            reset()
                            setState((pre) => ({ ...pre, EditHolidaysData: null }));
                        }}
                    />
                </div>
                <div className="modal-body p-4">
                    <form onSubmit={handleSubmit(onSubmit)} id='formholiday'>
                        <div className="card shadow-none mb-0">
                            <div className="card-body p-0">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group mb-3">
                                            <label htmlFor="officeId" className="form-label">
                                                Office <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                type="text"
                                                className={`form-control ${errors.officeId ? "is-invalid" : ""}`}
                                                id="officeId"
                                                {...register("officeId", { required: "Holiday Name is required" })}
                                            >
                                                <option value="" hidden>Select Office</option>
                                                {stateOffice?.officeList.length > 0 ? stateOffice?.officeList?.map((item) => {
                                                    return (
                                                        <option value={item?.id}>{item?.name}</option>
                                                    )
                                                }) : <option value="" hidden>Not Data Found</option>}
                                            </select>
                                            {errors.officeId && (
                                                <div className="form-text text-danger">{errors.officeId.message}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mb-3">
                                            <label htmlFor="holidayName" className="form-label">
                                                Holiday Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.holidayName ? "is-invalid" : ""}`}
                                                id="holidayName"
                                                placeholder='Holiday Name'
                                                {...register("holidayName", { required: "Holiday Name is required" })}
                                            />
                                            {errors.holidayName && (
                                                <div className="form-text text-danger">{errors.holidayName.message}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mb-3">
                                            <label htmlFor="holidayDate" className="form-label">
                                                Holiday Date <span className="text-danger">*</span>
                                            </label>
                                            <Controller
                                                name="holidayDate"
                                                control={control}
                                                rules={{
                                                    required: "Holiday Date is required",
                                                    validate: (value) => {
                                                        // No specific validation rule mentioned for holidays, but adding the structure for manual typed dates.
                                                        return true;
                                                    }
                                                }}
                                                defaultValue={moment().format('YYYY-MM-DD')}
                                                render={({ field }) => (
                                                    <DatePicker size="sm"
                                                        {...field}
                                                        id="holidayDate"
                                                        format="dd/MM/yyyy"
                                                        oneTap
                                                        placeholder="dd/mm/yyyy"
                                                        style={{ width: "100%" }}
                                                        value={field.value ? new Date(field.value) : null}
                                                        onChange={(date) => {
                                                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                                                        }}
                                                        shouldDisableDate={(date) => date < new Date(moment().startOf('day'))}
                                                        container={() => document.querySelector('.holiday-modal .modal-content') || document.body}
                                                        cleanable={false}
                                                    />
                                                )}
                                            />
                                            {errors.holidayDate && (
                                                <div className="form-text text-danger">{errors.holidayDate.message}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mb-3">
                                            <label htmlFor="description" className="form-label">
                                                Description <span className="text-danger">*</span>
                                            </label>
                                            <textarea
                                                className={`form-control ${errors.description ? "is-invalid" : ""}`}
                                                rows={3}
                                                id="description"
                                                placeholder="Enter Description here..."
                                                {...register("description", { required: "Description is required" })}
                                            />
                                            {errors.description && (
                                                <div className="form-text text-danger">{errors.description.message}</div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="modal-footer p-4">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                            clearErrors();
                            onClose();
                            reset()
                            setState((pre) => ({ ...pre, EditHolidaysData: null }));
                        }}
                    >
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary" form='formholiday'>
                        {isLoading ? <Spinner /> : EditHolidaysData ? "Edit Holidays" : "Add Holiday"}
                    </button>
                </div>
            </div>
        </Modal>

    )
}
